module.exports = __webpack_public_path__ + "static/img/whirlpool-logo.fbe6a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clientlogos/whirlpool-logo.png
// module id = tcFp
// module chunks = 1